<template>
  <aha-modal
    :title="title_DontLoseOut"
    ref="remove-card-info-popup"
    id="remove-card-info-popup"
    v-if="visible"
    @hide="handleCancelButton()"
  >
    <img
      src="@/assets/images/elements/dont-leave-subscription.svg"
      class="ml-auto mr-auto mb-4"
    >
    <p class="mb-4">
      <span v-html="$i18nPresenter.t('yourPlanCurrentlyOldPricingScheme')"></span>
    </p>
    <p class="mb-4">
      {{ $i18nPresenter.t('If you cancel your plan and buy a new one, you’ll pay the updated price.') }}
    </p>
    <p>{{ $i18nPresenter.t('Are you sure you want to continue?') }}</p>
    <template #action>
      <aha-button
        @click="handleCancelButton"
        has-margin-right
      >
        {{ $i18nPresenter.t('Stay') }}
      </aha-button>
      <aha-link
        :disabled="loadingConfirmRemoveCard"
        @click="handleOKButton"
      >
        <span class="font-bold">{{ $i18nPresenter.t('Continue') }}</span>
        <aha-spinner
          variant="dark"
          size="xs"
          class="ml-1"
          v-if="loadingConfirmRemoveCard"
        />
      </aha-link>
    </template>
    <div class="m-2 text-center text-red-100" v-if="error">
      {{ $i18nPresenter.t('Something went wrong, please contact us for support') }}
    </div>
  </aha-modal>
</template>
<script>
import * as Sentry from '@sentry/vue'
import storageKeys from '@/constant/storageKeys'
import Config from '@/config'
import stripeApi from '@/api/stripe'
import Util from '@/util'

export default {
  name: 'RemoveCardInfo',
  props: {
    currentUserPlan: {
      type: Object,
      default: () => ({}),
    },
    currentSubscription: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loadingConfirmRemoveCard: false,
      error: false,
      visible: false,
      data: {},
    }
  },
  computed: {
    isWhiteLabel() {
      return Util.checkWhiteLabelDomain()
    },
    title_DontLoseOut() {
      return this.$i18nPresenter.t('Don’t lose out!')
    },
  },
  mounted() {
    this.visible = true
  },
  methods: {
    handleOKButton() {
      if (this.currentUserPlan.group === 'one-time') {
        this.handleOKButtonOneTime()
        return
      }
      if (this.currentSubscription && this.currentSubscription.subscription.cancel_at_period_end) {
        this._removeCardInfo()
        return
      }
      localStorage.setItem(storageKeys.IS_REMOVE_CARD_PURPOSE, true)
      this.$router.push({ name: 'UserCancelSub' })
    },

    handleOKButtonOneTime() {
      if (this.loadingConfirmRemoveCard) return
      this.error = false
      this._removeCardInfo()
      Util.mixpanelTracking(
        'User Plan',
        'User remove card info',
        'User click on OK remove card info',
      )
    },
    handleCancelButton() {
      this.visible = false
      this.$emit('handleCancelRemoveCardInfo')
    },
    async _removeCardInfo() {
      this.loadingConfirmRemoveCard = true

      try {
        const { body: { ref } } = await stripeApi.removeCards()
        await this._turnOffAutoRenew(ref)
        this.$emit('handleRemoveCardInfo', this.data)
        this.loadingConfirmRemoveCard = false
      } catch {
        this.error = true
        this.loadingConfirmRemoveCard = false
      }
    },
    async _turnOffAutoRenew(ref) {
      try {
        await this.$http.post(Config.api.changeSubscription, {
          stop: true,
          ref,
        })
      } catch (err) {
        Sentry.captureException(err)
      }
    },
  },
}
</script>
